import React from "react"
import { Text } from "@/elements"
import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon"
import clsx from "clsx"

interface Props {
  label: string
  onClick: () => void
  selected?: boolean
}

export const SelectionButton: React.FC<Props> = ({ label, selected = false, onClick }) => {
  return (
    <div
      className={clsx(
        "flex h-[38px] cursor-pointer flex-row items-center gap-2 rounded-md p-2",
        selected ? "bg-fg-1 hover:bg-fg-2" : "bg-bg-2 hover:bg-bg-3"
      )}
      onClick={onClick}>
      <Text variant="body1" className={clsx(selected && "text-bg-1")} maxLines={1}>
        {label}
      </Text>
      {selected && <XMarkIcon className="size-[18px] stroke-bg-2" />}
    </div>
  )
}
